import { Templates } from "./assets";

let BlockUIConfig = (blockUIConfig: any) => {
    blockUIConfig.templateUrl = Templates.blockUI;
    blockUIConfig.delay = 500;
    blockUIConfig.requestFilter = function (config) {

        var message;
        switch (config.method) {
            case 'GET':
                message = 'Loading...';
                break;

            case 'POST':
                message = (config.params && config.params.query)
                    ? "Loading..."
                    : "Saving...";
                break;
            case 'DELETE':
                message = 'Deleting...';
                break;
            case 'PUT':
                message = 'Saving...';
                break;
        };

        return message;
    };
};

export default ['blockUIConfig', BlockUIConfig];


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/blockui-config.ts